/*
 * Copyright (c) 2025. Bolmate B.V.
 */

export enum NotificationInterval {
    INSTANT = 'INSTANT',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    YEAR = 'YEAR'
}

export enum NotificationType {
    REVIEWS = 'REVIEWS',
    PRODUCT_HIJACK = 'PRODUCT_HIJACK', // E.g. someone else changed the content of one of your (shared) products
    BUY_BOX = 'BUY_BOX',
}

export enum SubscriptionModuleName {
    NOTIFICATIONS = 'NOTIFICATIONS',
}

export enum SubscriptionModuleStatus {
    PAID = 'PAID',
    TRIAL = 'TRIAL',
    FREE = 'FREE',
    CANCELED = 'CANCELED',
    CANCELING = 'CANCELING'
}

export enum InvoiceOptionName {
    PREVIEW, EDIT, DOWNLOAD, DETAILS, SEND_INVOICE, UPLOAD_INVOICE, CREDIT,
    REVERSE_CHARGE, SET_NUMBER, CANCEL_EMAILS, COPY_ID
}